AndrewMartin.klaviyo = () => {
    !function(){if(!window.klaviyo){window._klOnsite=window._klOnsite||[];try{window.klaviyo=new Proxy({},{get:function(n,i){return"push"===i?function(){var n;(n=window._klOnsite).push.apply(n,arguments)}:function(){for(var n=arguments.length,o=new Array(n),w=0;w<n;w++)o[w]=arguments[w];var t="function"==typeof o[o.length-1]?o.pop():void 0,e=new Promise((function(n){window._klOnsite.push([i].concat(o,[function(i){t&&t(i),n(i)}]))}));return e}}})}catch(n){window.klaviyo=window.klaviyo||[],window.klaviyo.push=function(){var n;(n=window._klOnsite).push.apply(n,arguments)}}}}();

    console.log('Klaviyo initialised');

    const form = document.querySelector('.js-klaviyo-identify');

    if (!form) {
        console.error('Klaviyo form not found');
        return;
    }

    form.addEventListener('submit', (event) => {
        if (typeof klaviyo === 'undefined') {
            console.error('Klaviyo not initialised');
            return true;
        }

        const email = event.currentTarget.querySelector('input[name$="email"]').value || event.currentTarget.querySelector('input[name$="email]"]').value;

        if (!email) {
            console.error('No email address to send to klaviyo');
            return true;
        }

        klaviyo.identify({
            'email': email
        }).then(() => {
            console.log('Klaviyo identify success');
        });

        return true;
    });
}
